(function () {
  'use strict';

  angular
    .module('blocks.i18n')
    .service('currentSiteService', currentSiteService);

  function currentSiteService() {}
})();